.wrapper {
  background: #f2ede1;
  padding: 24px 20px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-top: 1px solid #eae5da;
  border-bottom: 1px solid #eae5da;
}

.label {
  color: #221e1a;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
}

.values {
  display: flex;
  align-items: center;
  gap: 4px;
}

.discount {
  color: #fffbf2;
  font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif;
  font-size: 12px;
  font-weight: 900;
  line-height: 16px;
  letter-spacing: 0.036px;
  background: #e44a08;
  border-radius: 8px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.oldPrice {
  color: #7a7670;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
  text-decoration: line-through;
}

.totalPrice {
  color: #221e1a;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.068px;
}

// `USD ` is a 4-character prefix, so the two amounts need to shrink to stay on one line.
.row.USD {
  .oldPrice,
  .totalPrice {
    font-size: 16px;
    white-space: nowrap;

    @media (max-width: 375px) {
      font-size: 15px;
    }
  }
}

// Dark mode
:global body.dark {
  :local {
    .wrapper {
      background: #2a2928;
    }

    .row {
      border-top: 1px solid #3e3c3a;
      border-bottom: 1px solid #3e3c3a;
    }

    .label,
    .totalPrice {
      color: #fffbf2;
    }
  }
}
